import { ref } from 'vue'
import { defineStore } from 'pinia'

export type SnackbarColor = 'error' | 'success' | 'info' | 'warning'

interface SnackbarState {
    show: boolean
    text: string
    color: SnackbarColor
}

/**
 * Small app-wide UI store. Its first job is replacing the native alert()
 * dialogs previously fired by the global error handlers in main.ts — those
 * blocked the whole page and showed raw error internals to end users.
 */
export const useUiStore = defineStore('ui', () => {
    const snackbar = ref<SnackbarState>({ show: false, text: '', color: 'info' })

    function notify(text: string, color: SnackbarColor = 'info') {
        snackbar.value = { show: true, text, color }
    }

    function reportError(text: string) {
        notify(text, 'error')
    }

    return { snackbar, notify, reportError }
})
